import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useScrollToAnchor } from '../../hooks/useScrollToAnchor'

export const ToTopOnRoute = () => {

    useScrollToAnchor()

    return <></>
}